export default {
	errors: {
		e400100: {
			title: 'Atenção',
			message: 'Código de verificação invalido. Verifique de novo.',
		},
		e400101: {
			title: 'Atenção',
			message: 'A conta precisa de ser ativada primeiro. Verifique o seu email.',
		},
		e400102: {
			title: 'Atenção',
			message: 'Esta conta não existe na nossa plataforma ou tem a password incorrecta. Verifique de novo os dos introduzidos.',
		}
	}
}



// WEBPACK FOOTER //
// ./src/i18n/errors/errors_pt.js